export const cancelButton = theme => ({
  color: theme.palette.secondary.medium,
  marginRight: theme.spacing(2),
});

export const drawerStyle = theme => ({
  alignItems: 'center',
  backgroundColor: theme.palette.surface.white,
  boxShadow: theme.shadows[1],
  display: 'flex',
  height: 56,
  justifyContent: 'space-between',
  paddingLeft: theme.spacing(2.5),
  position: 'fixed',
  width: '100%',
  // TODO: Update to appropriate z-index value
  zIndex: 1100,
  [theme.breakpoints.up('sm')]: {
    height: 64,
  },
});

export const header = theme => ({
  fontWeight: 700,
  [theme.breakpoints.down('md')]: {
    fontSize: 21,
  },
});

export const headerWrapper = theme => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  margin: theme.spacing(7, 0, 1),
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    margin: theme.spacing(8, 0, 1),
  },
  [theme.breakpoints.up('md')]: {
    gridTemplate: '1fr 1fr / 1fr 2fr 1fr',
    margin: theme.spacing(8, 0, 0),
  },
  [theme.breakpoints.up('lg')]: {
    margin: theme.spacing(6, 0, 0),
  },
});

export const infoIcon = {
  height: 18,
  width: 18,
};

export const rulesButtonStyles = theme => ({
  alignItems: 'center',
  alignSelf: 'start',
  color: theme.palette.primary.main,
  display: 'flex',
  gridColumnStart: 'unset',
  justifyContent: 'start',
  padding: theme.spacing(2, 0, 0, 3),
  textDecoration: 'none',
  [theme.breakpoints.up('md')]: {
    gridColumnStart: 3,
    gridRowStart: 1,
    justifySelf: 'flex-end',
    marginBottom: 'unset',
    marginTop: theme.spacing(3),
    padding: theme.spacing(0, 2, 0, 0),
  },
});

export const stepperStyles = theme => ({
  borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
  padding: theme.spacing(3),
  [theme.breakpoints.up('md')]: {
    borderBottom: 'none',
    gridColumnStart: 2,
    // paddingTop: 'unset',
  },
});
